import axios from "axios";
import { backendUrl, isNative } from "@/lib/mobile";
import { readNativeSession, writeNativeSession } from "@/lib/nativeSession";

const BACKEND_URL = backendUrl();
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: !isNative,
  timeout: 20000,
});

// Restore from platform-encrypted storage before any native API request.
// On web, sessionStorage holds the JWT; on native, the secure keychain does.
let nativeToken = "";
let restoring;
export async function restoreNativeSession() {
  if (!restoring) restoring = readNativeSession().then((token) => { nativeToken = token; }).catch((error) => {
    restoring = undefined;
    throw error;
  });
  await restoring;
}
export async function setNativeSession(token) {
  await restoreNativeSession();
  await writeNativeSession(token || "");
  nativeToken = token || "";
}
api.interceptors.request.use(async (config) => {
  await restoreNativeSession();
  if (nativeToken) config.headers.Authorization = `Bearer ${nativeToken}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
